/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Ctrl_S1_DescInputs */

const en_mk_ctrl_s1_desc = /** @type {(inputs: Mk_Ctrl_S1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a public repo URL: 11 signals, 100 points, plus leaked secrets. Offline: bystep doctor --repo with the identical score.`)
};

const id_mk_ctrl_s1_desc = /** @type {(inputs: Mk_Ctrl_S1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempel URL repo publik: 11 sinyal, 100 poin, plus kunci rahasia yang tertinggal. Offline: bystep doctor --repo dengan skor identik.`)
};

/**
* | output |
* | --- |
* | "Paste a public repo URL: 11 signals, 100 points, plus leaked secrets. Offline: bystep doctor --repo with the identical score." |
*
* @param {Mk_Ctrl_S1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_ctrl_s1_desc = /** @type {((inputs?: Mk_Ctrl_S1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Ctrl_S1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_ctrl_s1_desc(inputs)
	return en_mk_ctrl_s1_desc(inputs)
});